"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inferStatement = void 0;
const util_1 = require("../../util");
const substitution_1 = require("../substitution");
const unification_1 = require("../unification");
const expressions_1 = require("./expressions");
const builders_1 = require("../types/builders");
const helpers_1 = require("./helpers");
function inferStatement(context, statement) {
    const { kind, name, expression } = statement;
    if (name in context) {
        throw new helpers_1.NameError(`Name Error: "${name}" was declared twice`);
    }
    try {
        switch (kind) {
            case "FunctionDefinition":
                return inferFunctionDefinition(context, name, expression);
            case "Assignment":
                return inferAssignment(context, name, expression);
            default:
                util_1.assertUnreachable(kind);
        }
    }
    catch (e) {
        throw new e.constructor(e.message + ` in definition of "${name}".`);
    }
}
exports.inferStatement = inferStatement;
function inferAssignment(context, name, expression) {
    const type = expressions_1.inferExpression(expression, context).type;
    return {
        ...context,
        [name]: helpers_1.generalize(context, type),
    };
}
function inferFunctionDefinition(context, name, body) {
    const contextWithSelfReference = {
        ...context,
        [name]: builders_1.unboundScheme(builders_1.typeVar('u1')),
    };
    const { substitution: sub1, type: expressionType } = expressions_1.inferExpression(body, contextWithSelfReference);
    const updatedContext = substitution_1.substituteInContext(sub1, contextWithSelfReference);
    const sub2 = unification_1.unify(expressionType, helpers_1.instantiate(updatedContext[name]));
    const functionType = substitution_1.substituteInType(sub2, expressionType);
    return {
        ...updatedContext,
        [name]: helpers_1.generalize(context, functionType),
    };
}
//# sourceMappingURL=statements.js.map